var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_812_118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M0.629159 2.53285C0.711235 2.53274 0.792521 2.54888 0.868326 2.58035C0.944131 2.61181 1.01295 2.65798 1.07083 2.71618L4.26791 5.91285C4.36464 6.0096 4.47949 6.08636 4.60588 6.13872C4.73228 6.19109 4.86776 6.21804 5.00458 6.21804C5.14139 6.21804 5.27687 6.19109 5.40327 6.13872C5.52967 6.08636 5.64451 6.0096 5.74124 5.91285L8.93333 2.72035C8.99098 2.66065 9.05995 2.61304 9.1362 2.58028C9.21245 2.54753 9.29446 2.53029 9.37745 2.52956C9.46044 2.52884 9.54274 2.54466 9.61955 2.57608C9.69636 2.60751 9.76614 2.65392 9.82482 2.7126C9.8835 2.77128 9.92991 2.84106 9.96134 2.91787C9.99276 2.99469 10.0086 3.07698 10.0079 3.15997C10.0071 3.24296 9.98989 3.32497 9.95714 3.40122C9.92438 3.47748 9.87677 3.54644 9.81708 3.6041L6.62499 6.7966C6.19495 7.22584 5.61218 7.46691 5.00458 7.46691C4.39698 7.46691 3.8142 7.22584 3.38416 6.7966L0.187076 3.59993C0.099611 3.51252 0.0400399 3.40113 0.0159007 3.27986C-0.0082385 3.15858 0.00413906 3.03287 0.0514672 2.91863C0.0987953 2.80439 0.178947 2.70676 0.28178 2.63809C0.384612 2.56942 0.505505 2.53279 0.629159 2.53285Z",
    fill: "#212633"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.8f9ca8b932ef56f2b24a0e34b2191d88.svg";
export { ForwardRef as ReactComponent };